import angular from 'angular'
import template from './template.html'

angular.module('nominas.cotizacion')
  .component('nominasCotizacionInformacion', {
    controller: Component,
    template: template,
  });

function Component($dialog, $q) {
  let $ctrl = this;
  $ctrl.Proyectos = totalizarProyectos();
  // Methods
  $ctrl.guardar = guardar;
  $ctrl.guardando = false;

  function totalizarProyectos() {
    let proyectos = [],
      resumen = {};

    $ctrl.data.Empleados.forEach(function (item) {
      if (!resumen[item.ID_Proyecto]) {
        resumen[item.ID_Proyecto] = {
          Proyecto: item.Proyecto,
          Empleados: 0,
          Percepciones: 0,
          Deducciones: 0,
          Total: 0,
        };
        proyectos.push(resumen[item.ID_Proyecto]);
      }
      resumen[item.ID_Proyecto].Empleados++;
      resumen[item.ID_Proyecto].Percepciones += item.Percepciones.reduce(function (prev, next) {
        return prev + next.Importe;
      }, 0);
      resumen[item.ID_Proyecto].Deducciones += item.Deducciones.reduce(function (prev, next) {
        return prev + next.Importe;
      }, 0);
      resumen[item.ID_Proyecto].Total = resumen[item.ID_Proyecto].Percepciones - resumen[item.ID_Proyecto].Deducciones;
    });

    return proyectos;
  }

  function guardar(cerrar) {
    let confirm = cerrar ? $dialog.confirm('La cotización ya no podrá editarse una vez haya sido cerrada. ¿Desea continuar?')
      : $q.when();

    confirm.then(function () {
      $ctrl.guardando = true;
      $ctrl.data.guardar(cerrar)
        .finally(function () {
          $ctrl.guardando = false;
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cotizacion/components/informacion/controller.js